import type { DemoScript } from "../types";
import { NOTES_SCRIPT_COPY } from "./notes-script.copy";

export const buildNotesScript = (): DemoScript => [
  {
    id: "notes-intro",
    narrative: NOTES_SCRIPT_COPY.notesIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "notes-toolbar",
    narrative: NOTES_SCRIPT_COPY.notesToolbar.narrative,
    zoomTargetId: "notes-toolbar",
    disableZoom: true,
    callout: {
      targetId: "notes-toolbar",
      text: NOTES_SCRIPT_COPY.notesToolbar.callout,
    },
    durationMs: 5000,
  },
  {
    id: "notes-list",
    narrative: NOTES_SCRIPT_COPY.notesList.narrative,
    zoomTargetId: "notes-list",
    callout: {
      targetId: "notes-list",
      text: NOTES_SCRIPT_COPY.notesList.callout,
    },
    durationMs: 5400,
  },
  {
    id: "notes-overview",
    narrative: NOTES_SCRIPT_COPY.notesOverview.narrative,
    durationMs: 1800,
  },
  {
    id: "notes-editor",
    narrative: NOTES_SCRIPT_COPY.notesEditor.narrative,
    zoomTargetId: "notes-editor",
    callout: {
      targetId: "notes-editor",
      text: NOTES_SCRIPT_COPY.notesEditor.callout,
    },
    durationMs: 5400,
  },
];
